<template>
  <div class="f-paper-page">
    <div class="title-container">
      <h1>{{activeLanguage.chartaContent.generalTitle}}</h1>
    </div>

    <div id="carta-container">
      <b-row>
        <b-col class="charta-content" sm="12" lg="6">
          <div class="paragraph-title section-title-left">
            <p>{{activeLanguage.chartaContent.chapter1.title}}</p>
          </div>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter1.text}}
          </p>
          <template v-if="activeLanguage.chartaContent.chapter1.purposes">
            <ul class="text-left">
              <li v-for="(purpose, idx) in activeLanguage.chartaContent.chapter1.purposes" :key="idx">
                {{purpose}}
              </li>
            </ul>
          </template>
        </b-col>
        <b-col sm="12" lg="6" class="charta-content">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background1_resized.jpg" alt="AlpFoodway">
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" lg="6" class="charta-content" v-show="!isSmallWindow">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background2_resized.jpg" alt="AlpFoodway">
        </b-col>
        <b-col sm="12" lg="6" class="charta-content">
          <div class="paragraph-title section-title-left">
            <p>{{activeLanguage.chartaContent.chapter2.title}}</p>
          </div>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter2.text}}
          </p>
        </b-col>
        <b-col sm="12" lg="6" class="charta-content" v-show="isSmallWindow">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background2_resized.jpg" alt="AlpFoodway">
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" lg="6" class="charta-content">
          <div class="paragraph-title section-title-left">
            <p>{{activeLanguage.chartaContent.chapter3.title}}</p>
          </div>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter3.text.p1}}
          </p>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter3.text.p2}}
          </p>
        </b-col>
        <b-col sm="12" lg="6" class="charta-content">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background3_resized.jpg" alt="AlpFoodway">
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" lg="6" class="charta-content" v-show="!isSmallWindow">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background4_resized.jpg" alt="AlpFoodway">
        </b-col>
        <b-col sm="12" lg="6" class="charta-content">
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter3.text.p3}}
          </p>
        </b-col>
        <b-col sm="12" lg="6" class="charta-content" v-show="isSmallWindow">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background4_resized.jpg" alt="AlpFoodway">
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" lg="6" class="charta-content">
          <div class="paragraph-title section-title-left">
            <p>{{activeLanguage.chartaContent.chapter4.title}}</p>
          </div>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter4.text.p1}}
          </p>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter4.text.p2}}
          </p>
        </b-col>
        <b-col sm="12" lg="6" class="charta-content">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background5_resized.jpg" alt="AlpFoodway">
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" lg="6" class="charta-content" v-show="!isSmallWindow">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background6_resized.jpg" alt="AlpFoodway">
        </b-col>
        <b-col sm="12" lg="6" class="charta-content">
          <div class="paragraph-title section-title-left">
            <p>{{activeLanguage.chartaContent.chapter5.title}}</p>
          </div>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter5.text.p1}}
          </p>
        </b-col>
        <b-col sm="12" lg="6" class="charta-content" v-show="isSmallWindow">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background6_resized.jpg" alt="AlpFoodway">
        </b-col>
      </b-row>

      <template v-for="(ul, ul_index) in activeLanguage.chartaContent.chapter5.text.uls">
        <b-row>
          <b-col sm="12" lg="6" v-if="ul_index % 2 === 1 && !isSmallWindow" class="charta-content">
            <img :src="imagePath(ul_index)" alt="AlpFoodway">
          </b-col>
          <b-col sm="12" lg="6" class="charta-content">
            <p class="as-people-style" :key="ul_index">
              {{ul.title}}
            </p>
            <ul class="text-left">
              <li v-for="(li, index) in ul.lis" :key="index">
                {{li}}
              </li>
            </ul>
          </b-col>
          <b-col sm="12" lg="6" v-if="!(ul_index % 2 === 1) || isSmallWindow" class="charta-content">
            <img :src="imagePath(ul_index)" alt="AlpFoodway">
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col sm="12" lg="6" class="charta-content">
          <img src="../../../assets/alpfoodway_images/alpfoodway_background18_resized.jpg" alt="AlpFoodway">
        </b-col>
        <b-col sm="12" lg="6" class="charta-content">
          <div class="paragraph-title section-title-left">
            <p>{{activeLanguage.chartaContent.chapter6.title}}</p>
          </div>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter6.text.p1}}
          </p>
          <p class="paragraph-body">
            {{activeLanguage.chartaContent.chapter6.text.p2}}
          </p>
        </b-col>
      </b-row>

      <p class="paragraph-body text-center stress">
        {{activeLanguage.chartaContent.catchPhrase}}
      </p>

      <b-row class="my-3 button-align" key="submitButton">
        <b-col sm="12">
          <b-button id="signButton" @click="loadSignPetition">{{activeLanguage.signPetition}}</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import SignPetitionPage from '../signPetitionPageComponents/SignPetitionPage'

  export default {
    name: 'PaperPage',
    props: {
      default: {
        type: Object
      }
    },
    data () {
      return {
        isSmallWindow: false
      }
    },
    mounted () {
      this.$store.commit('setCurrentView', this.default)
      this.checkWindowSize()
      window.addEventListener('resize', () => this.checkWindowSize())
    },
    computed: {
      activeLanguage () {
        let currLang = this.$translations[this.$store.getters.currentLanguageValue]
        if (currLang.chartaContent) {
          return this.$translations[this.$store.getters.currentLanguageValue]
        } else {
          return this.$translations['English']
        }
      }
    },
    methods: {
      loadSignPetition () {
        this.$store.commit('setCurrentView', SignPetitionPage)
        this.$router.push('/sign-petition')
      },
      imagePath (imageNumber) {
        imageNumber = imageNumber + 7
        return require('../../../assets/alpfoodway_images/alpfoodway_background' + imageNumber + '_resized.jpg')
      },
      checkWindowSize () {
        if ((!this.isSmallWindow) && window.innerWidth < 1051) {
          this.isSmallWindow = true
        } else if (this.isSmallWindow && window.innerWidth > 1051) {
          this.isSmallWindow = false
        }
      }
    }
  }
</script>

<style scoped>
  .paragraph-title {
    width: 100%;
    margin-top: 3%;
  }

  .paragraph-title > p {
    /*text-align: left;*/
    /*border-bottom: solid 1px grey;*/
    font-size: 20pt;
    color: #c41c21;
    /*margin: 0 0 1%;*/
    padding-bottom: 0;
    /*display: table-cell;*/
    display: inline;
    text-transform: uppercase;
  }

  .paragraph-body {
    text-align: justify;
  }

  .as-people-style {
    text-align: left;
    font-weight: bold;
    color: #c41c21;
    font-size: 30px;
  }

  #signButton {
    background-color: #c41c21 !important;
    border-color: #c41c21 !important;
  }

  .section-title-right {
    text-align: right;

  }

  .section-title-left {
    text-align: left;
  }

  ul {
    list-style: none;
  }

  ul li::before {
    content: "\2022";
    color: #c41c21;
    font-weight: bold;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
  }

  img {
    width: 100%;
    border-radius: 10px;
  }

  .stress {
    padding-top: 2%;
    font-weight: bold;
    font-size: 20px;
    color: #c41c21;
  }

  #carta-container {
    margin-right: 5%;
    margin-left: 5%
  }

  .charta-content {
    margin: auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/paperPageComponents/PaperPage.vue